import { FC } from 'react';
import { LoadingButton, LoadingButtonProps } from '@mui/lab';
import { useFormikContext } from 'formik';
import { useSnackbar } from '../../contexts/snackbar.context.tsx';

export type SubmitButtonProps = LoadingButtonProps & {
  children: React.ReactNode;
};

export const SubmitButton: FC<SubmitButtonProps> = ({ children, ...props }) => {
  const { isSubmitting, validateForm, setSubmitting, submitForm, setTouched } = useFormikContext();
  const { push } = useSnackbar();

  const onClick = async (e: any) => {
    e.preventDefault();
    const errors = await validateForm();

    if (Object.keys(errors).length > 0) {
      // Mark all fields with errors as touched so inline errors appear
      const touched = Object.keys(errors).reduce(
        (acc, key) => {
          acc[key] = true;
          return acc;
        },
        {} as Record<string, boolean>
      );
      setTouched(touched);
      push({ message: 'Please fill in all required fields', type: 'error' });
    } else {
      submitForm();
    }

    setSubmitting(false);
  };

  return (
    <LoadingButton loading={isSubmitting} fullWidth variant="contained" type="submit" color="primary" {...props} onClick={onClick}>
      {children}
    </LoadingButton>
  );
};
